export default __webpack_public_path__ + "static/media/hassan_ecran_adieux_salim_NL.af2673ee.png";